import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Principal } from '@b1links/core';
import { portalKey } from '../platform';

interface AuthState {
  token: string | null;
  principal: Principal | null;
  setSession(token: string, principal: Principal): void;
  logout(): void;
  can(perm: string): boolean;
}

export const useAuth = create<AuthState>()(persist((set, get) => ({
  token: null, principal: null,
  setSession: (token, principal) => set({ token, principal }),
  logout: () => set({ token: null, principal: null }),
  can: (perm) => {
    const p = get().principal;
    if (!p) return false;
    if (p.mode === 'sap' || p.superUser || p.permissions.includes('*')) return true;
    return p.permissions.includes(perm);
  },
  // Scoped to the portal: the three portals share an origin, so a single key would mean signing into one
  // signs you into all of them. Each keeps its own session, and signing out of one leaves the others alone.
}), { name: `b1links.auth.${portalKey()}` }));
